import React from "react";
import { useTranslation } from "react-i18next";
import { queryCache, useMutation } from "react-query";

import { Button, showNotification } from "fe-shared/src/components";
import { CloseIcon } from "fe-shared/src/components/Icons";

import { REQUESTS_QUERY_KEY, REQUEST_ACTIVITIES_QUERY_KEY } from "consts";

import * as api from "./modules/api";

interface Props {
  requestNumber: string;
}

const PickupRequestApproveButton = (props: Props) => {
  const { requestNumber } = props;
  const { t } = useTranslation();

  const [approve, approveResult] = useMutation(api.approvePickupRequest, {
    onSuccess: () => {
      queryCache.invalidateQueries(REQUESTS_QUERY_KEY);
      queryCache.invalidateQueries([
        REQUEST_ACTIVITIES_QUERY_KEY,
        requestNumber,
      ]);
      showNotification(t("pickupRequests.details.approveSuccess"));
    },
    onError: () => {
      showNotification(
        t("pickupRequests.details.approveError"),
        undefined,
        CloseIcon
      );
    },
  });

  return (
    <Button
      id="request-approve-button"
      disabled={approveResult.isLoading}
      onClick={() => approve(requestNumber)}
    >
      {t("pickupRequests.details.approve")}
    </Button>
  );
};

export default PickupRequestApproveButton;
